const styles = (theme) => ({
    checkboxGridItem: {
        width: 170,
    },
});

export default styles;
